import { render, staticRenderFns } from "./manageWells.vue?vue&type=template&id=33d1a99c"
import script from "./manageWells.vue?vue&type=script&lang=ts"
export * from "./manageWells.vue?vue&type=script&lang=ts"
import style0 from "./manageWells.vue?vue&type=style&index=0&id=33d1a99c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports